export const tinSearchTypeLabel = 'TIN search type';
